module.exports = __webpack_public_path__ + "yellow-line-2.svg?7e7af0b89d0b58204b2b8eba6a85551a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yellow-line-2.svg
// module id = 395
// module chunks = 0